import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styles: [],
  standalone: false,
})
export class LoginComponent {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) {}
  email: string = "";
  password: string = "";
  showPassword = false;
  manageCredentials(variableName: "email" | "password", value: any) {
    if (value?.value) {
      this[variableName] = value?.value;
    }
  }

  recoveryPassword() {
    this.router.navigate(["/recupero-password"]);
  }
  login() {
    this.loader.on();
    this.rest
      .post(api.endpoint.login, {
        email: this.email,
        password: this.password,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.rest.setToken(value.access_token);
          localStorage.setItem("refresh_token", value.refresh_token);
          localStorage.setItem("user", JSON.stringify(value));
          localStorage.setItem("roleId", value.role_id);
          if (value.role_id == 2 || value.role_id == 3) {
            this.router.navigate(["prenotazioni"]);
          } else {
            this.router.navigate(["dashboard"]);
          }
        },
        error: (value) => {
          this.message.showMessage(value.error.message, "error");
          this.loader.off(true);
        },
      });
  }

  registration() {
    this.router.navigate(["/registrazione"]);
  }
}
